module.exports = __webpack_public_path__ + "static/media/icon-target.13a3359f.svg";